<template>
  <div class="calculator__items">
    <div class="calculator__item calculator__item_active">
      <div class="calculator__item-content">
        <div class="calculator__cols">
          <div class="calculator__col">
            <div class="calculator-form">
              <ul class="calculator-form__fields">
                <li
                  class="calculator-form__field calculator-form__field_input calculator-form__field_full-width"
                >
                  <div class="calculator-field__label">
                    Отправитель
                  </div>
                  <div
                    class="field-input calc__input"
                    :class="{'calc__input-error': validations.orderPIP.sender.name.$error}"
                  >
                    <label>
                      <input
                        v-if="!isCustoms"
                        id="sender-name"
                        ref="senderName"
                        v-model.trim="orderPIP.sender.name"
                        class="field-input__inner"
                        :placeholder="$t('calc.form.sender_name')"
                        required
                        type="text"
                        autocomplete="new-password"
                        @blur="validations.orderPIP.sender.name.$touch()"
                        @focus="() => scrollToEl($refs.senderName)"
                      >
                      <InputNameLatin
                        v-else
                        v-model.trim="orderPIP.sender.name"
                        ref="senderNameLatin"
                        class="field-input__inner"
                        :placeholder="$t('calc.form.sender_name')"
                        required
                        type="text"
                        autocomplete="new-password"
                        @blur="validations.orderPIP.sender.name.$touch()"
                        @focus="() => scrollToEl($refs.senderNameLatin)"
                      />
                    </label>
                    <div
                      v-if="!validations.orderPIP.sender.name.required"
                      class="calc__field-error"
                    >
                      Обязательно для заполнения
                    </div>

                    <div
                      v-else-if="!validations.orderPIP.sender.name.validName"
                      class="calc__field-error"
                    >
                      <template v-if="!calcImport">Только буквы</template>
                      <template v-else>Должно содержать 2 или 3 слова</template>
                    </div>
                    <div
                      v-else-if="validations.orderPIP.sender.name.$error && !orderPIP.sender.name.length"
                      class="calc__field-error"
                    >
                      Обязательно для заполнения
                    </div>
                    <div
                      v-else-if="validations.orderPIP.sender.name.$error && !validations.orderPIP.sender.name.validNameLatin"
                      class="calc__field-error"
                    >
                      Ввод только на латинице
                    </div>
                    <div
                      v-else-if="validations.orderPIP.sender.name.$error && !validations.orderPIP.sender.name.validName"
                      class="calc__field-error"
                    >
                      <template v-if="!calcImport">Только буквы</template>
                      <template v-else>Должно содержать 2 или 3 слова</template>
                    </div>
                    <div
                      v-if="isCustoms"
                      class="field__notice"
                    >
                      Пожалуйста, указывайте ФИО латинскими буквами
                    </div>
                  </div>
                </li>

                <li
                  class="calculator-form__field calculator-form__field_input calculator-form__field_full-width"
                >
                  <div
                    class="field-input calc__input"
                    :class="{'calc__input-error': validations.orderPIP.sender.phone.$error}"
                  >
                    <label>
                      <InputPhone
                        ref="senderPhone"
                        v-model="orderPIP.sender.phone"
                        :required="true"
                        :show-mask-on-focus="true"
                        :show-mask-on-hover="true"
                        :dynamic-mask="true"
                        :mask="orderPIP.sender.mask"
                        :placeholder="$t('calc.form.phone')"
                        @change-phone="onEnteredPhoneSender"
                        @blur-phone="validations.orderPIP.sender.phone.$touch()"
                        @focus="() => scrollToEl($refs.senderPhone)"
                      />
                    </label>
                    <div
                      v-if="!validations.orderPIP.sender.phone.required"
                      class="calc__field-error"
                    >
                      Обязательно для заполнения
                    </div>

                    <div
                      v-else-if="!validations.orderPIP.sender.phone.validPhone"
                      class="calc__field-error"
                    >
                      Заполните номер телефона
                    </div>
                    <div
                      v-else-if="validations.orderPIP.sender.phone.$error && !orderPIP.sender.phone.length"
                      class="calc__field-error"
                    >
                      Обязательно для заполнения
                    </div>
                    <div
                      v-else-if="validations.orderPIP.sender.phone.$error && !validations.orderPIP.sender.phone.validPhone"
                      class="calc__field-error"
                    >
                      Заполните номер телефона
                    </div>
                  </div>
                </li>
                <li
                  v-if="!hideFormEmail"
                  class="calculator-form__field calculator-form__field_input calculator-form__field_full-width"
                >
                  <div
                    class="field-input calc__input"
                    :class="{'calc__input-error': validations.orderPIP.sender.email.$error}"
                  >
                    <label>
                      <input
                        id="sender-email"
                        ref="senderEmail"
                        v-model="orderPIP.sender.email"
                        class="field-input__inner"
                        :placeholder="$t('calc.form.el-pochta')"
                        required=""
                        type="email"
                        autocomplete="new-password"
                        @blur="validations.orderPIP.sender.email.$touch()"
                        @focus="() => scrollToEl($refs.senderEmail)"
                      >
                    </label>
                    <div
                      v-if="!validations.orderPIP.sender.email.required"
                      class="calc__field-error"
                    >
                      Обязательно для заполнения
                    </div>

                    <div
                      v-else-if="!validations.orderPIP.sender.email.validFormat"
                      class="calc__field-error"
                    >
                      Введите e-mail в верном формате
                    </div>

                    <div
                      v-else-if="validations.orderPIP.sender.email.$error && !orderPIP.sender.email.length"
                      class="calc__field-error"
                    >
                      Обязательно для заполнения
                    </div>
                  </div>
                </li>
              </ul>
              <CalcComment
                v-if="isMobile"
                class="mt-2"
              >
                <div class="d-flex align-items-center">
                  <svg
                    class="me-2"
                    width="20px"
                    height="20px"
                  >
                    <use xlink:href="#info2" />
                  </svg>
                  Все поля обязательны для заполнения
                </div>
              </CalcComment>

            </div>
            <ul
              v-if="(!hideInputPassport && !hideAllPassport) && !isCustoms"
              class="calculator-form__fields"
            >
              <li
                v-if="recipientDetailsOtherCountry && !isCustoms"
                class="calculator-form__field calculator-form__field_full-width calculator__radio"
              >
                <span class="field-radio">
                  <input
                    id="passportRus"
                    v-model="orderPIP.passport_type"
                    class="field-radio__input"
                    type="radio"
                    name="passport_type"
                    value="1"
                  >
                  <label
                    class="field-radio__label"
                    for="passportRus"
                  >
                    <span class="field-radio__text">
                      {{ $t('calc.form.password_rf') }}
                    </span>
                  </label>
                </span>

                <span
                  class="field-radio"
                  :style="getPassportTypeStyle"
                >
                  <input
                    id="passportOther"
                    v-model="orderPIP.passport_type"
                    class="field-radio__input"
                    type="radio"
                    name="passport_type"
                    value="2"
                  >
                  <label
                    class="field-radio__label"
                    for="passportOther"
                  >
                    <span class="field-radio__text">{{ $t('calc.form.pasport-ne-rf') }}</span>
                  </label>
                </span>
              </li>
              <li
                v-if="isPassportRus"
                class="calculator-form__field calculator-form__field_input calculator-form__field_fix-width"
              >
                <div
                  class="field-input calc__input"
                  :class="{'calc__input-error': validations.orderPIP.sender.document_series.$error}"
                >
                  <label>
                    <input
                      ref="senderDocumentSeries"
                      v-model="orderPIP.sender.document_series"
                      v-mask="'## ##'"
                      type="text"
                      class="field-input__inner"
                      :placeholder="$t('calc.form.seriya')"
                      autocomplete="new-password"
                      @blur="validations.orderPIP.sender.document_series.$touch()"
                      @focus="() => scrollToEl($refs.senderDocumentSeries)"
                    >
                  </label>
                  <div
                    v-if="!validations.orderPIP.sender.document_series.required"
                    class="calc__field-error"
                  >
                    Обязательно для заполнения
                  </div>

                  <div
                    v-else-if="!validations.orderPIP.sender.document_series.minLength"
                    class="calc__field-error"
                  >
                    Введите в правильном формате
                  </div>

                  <div
                    v-else-if="validations.orderPIP.sender.document_series.$error && orderPIP.sender.document_series.length && orderPIP.sender.document_series.length < 5"
                    class="calc__field-error"
                  >
                    Введите в правильном формате
                  </div>

                  <div
                    v-else-if="validations.orderPIP.sender.document_series.$error && !orderPIP.sender.document_series.length"
                    class="calc__field-error"
                  >
                    Обязательно для заполнения
                  </div>
                </div>
              </li>
              <li
                v-if="isPassportRus"
                class="calculator-form__field calculator-form__field_input"
              >
                <div
                  class="field-input calc__input"
                  :class="{'calc__input-error': validations.orderPIP.sender.document_num.$error}"
                >
                  <label>
                    <input
                      ref="senderDocumentNum"
                      v-model="orderPIP.sender.document_num"
                      v-mask="'## ## ##'"
                      type="text"
                      class="field-input__inner"
                      :placeholder="$t('calc.form.nomer')"
                      autocomplete="new-password"
                      @blur="validations.orderPIP.sender.document_num.$touch()"
                      @focus="() => scrollToEl($refs.senderDocumentNum)"
                    >
                  </label>
                  <div
                    v-if="!validations.orderPIP.sender.document_num.required"
                    class="calc__field-error"
                  >
                    Обязательно для заполнения
                  </div>

                  <div
                    v-else-if="!validations.orderPIP.sender.document_num.minLength"
                    class="calc__field-error"
                  >
                    Введите в правильном формате
                  </div>

                  <div
                    v-else-if="validations.orderPIP.sender.document_num.$error && orderPIP.sender.document_num.length && orderPIP.sender.document_num.length < 8"
                    class="calc__field-error"
                  >
                    Введите в правильном формате
                  </div>

                  <div
                    v-else-if="validations.orderPIP.sender.document_num.$error && !orderPIP.sender.document_num.length"
                    class="calc__field-error"
                  >
                    Обязательно для заполнения
                  </div>
                </div>
              </li>
              <li
                v-else
                class="calculator-form__field calculator-form__field_input calculator-form__field_full-width"
              >
                <div
                  class="field-input calc__input"
                  :class="{'calc__input-error': validations.orderPIP.sender.document_num_other.$error}"
                >
                  <label>
                    <input
                      ref="senderDocumentOther"
                      v-model="orderPIP.sender.document_num_other"
                      type="text"
                      class="field-input__inner"
                      placeholder="Номер паспорта"
                      autocomplete="new-password"
                      @blur="validations.orderPIP.sender.document_num_other.$touch()"
                      @focus="() => scrollToEl($refs.senderDocumentOther)"
                    >
                  </label>
                  <div
                    v-if="!validations.orderPIP.sender.document_num_other.required"
                    class="calc__field-error"
                  >
                    Обязательно для заполнения
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="calculator__col">
            <div class="calculator-form">
              <p
                v-if="recipientDetailsOtherCountry && !isCustoms"
                class="calculator__notification"
              >
                <svg
                  class="warning-icon"
                  width="16"
                  height="16"
                >
                  <use xlink:href="#warning" />
                </svg>
                <span class="calculator__notification-text">Пожалуйста, вводите правильные ФИО получателя, без ошибок. При отправлении в другую страну опечатка в ФИО может стать причиной отказа в доставке.</span>
              </p>
              <ul class="calculator-form__fields">
                <li
                  class="calculator-form__field calculator-form__field_input calculator-form__field_full-width"
                >
                  <div class="calculator-field__label">
                    Получатель
                  </div>
                  <div
                    class="field-input calc__input"
                    :class="{'calc__input-error': validations.orderPIP.receiver.name.$error}"
                  >
                    <label>
                      <input
                        v-if="!isCustoms"
                        id="recipient-name"
                        ref="recipientName"
                        v-model.trim="orderPIP.receiver.name"
                        class="field-input__inner"
                        :placeholder="$t('calc.form.fio-poluchatelya')"
                        required
                        type="text"
                        autocomplete="new-password"
                        @blur="validations.orderPIP.receiver.name.$touch()"
                        @focus="() => scrollToEl($refs.recipientName)"
                      >
                      <InputNameLatin
                        v-else
                        ref="recipientNameLatin"
                        v-model.trim="orderPIP.receiver.name"
                        class="field-input__inner"
                        :placeholder="$t('calc.form.fio-poluchatelya')"
                        required
                        type="text"
                        autocomplete="new-password"
                        @blur="validations.orderPIP.receiver.name.$touch()"
                        @focus="() => scrollToEl($refs.recipientNameLatin)"
                      />
                    </label>
                    <div
                      v-if="!validations.orderPIP.receiver.name.required"
                      class="calc__field-error"
                    >
                      Обязательно для заполнения
                    </div>

                    <div
                      v-else-if="!validations.orderPIP.receiver.name.validName"
                      class="calc__field-error"
                    >
                      <template v-if="!calcImport">Только буквы</template>
                      <template v-else>Должно содержать 2 или 3 слова</template>
                    </div>
                    <div
                      v-else-if="validations.orderPIP.receiver.name.$error && !orderPIP.receiver.name.length"
                      class="calc__field-error"
                    >
                      Обязательно для заполнения
                    </div>
                    <div
                      v-else-if="validations.orderPIP.receiver.name.$error && !validations.orderPIP.receiver.name.validNameLatin"
                      class="calc__field-error"
                    >
                      Ввод только на латинице
                    </div>
                    <div
                      v-else-if="validations.orderPIP.receiver.name.$error && !validations.orderPIP.receiver.name.validName"
                      class="calc__field-error"
                    >
                      <template v-if="!calcImport">Только буквы</template>
                      <template v-else>Должно содержать 2 или 3 слова</template>
                    </div>
                    <div
                      v-if="isCustoms"
                      class="field__notice"
                    >
                      Пожалуйста, указывайте ФИО латинскими буквами
                    </div>
                  </div>
                </li>
                <li class="calculator-form__field calculator-form__field_input calculator-form__field_full-width">
                  <div
                    class="field-input calc__input"
                    :class="{'calc__input-error': validations.orderPIP.receiver.phone.$error}"
                  >
                    <label>
                      <InputPhone
                        ref="receiverPhone"
                        v-model="orderPIP.receiver.phone"
                        :required="true"
                        :show-mask-on-focus="true"
                        :show-mask-on-hover="true"
                        :mask="orderPIP.receiver.mask"
                        :dynamic-mask="true"
                        :placeholder="$t('calc.form.phone')"
                        @change-phone="onEnteredPhoneReceiver"
                        @blur-phone="validations.orderPIP.receiver.phone.$touch()"
                        @focus="() => scrollToEl($refs.receiverPhone)"
                      />
                    </label>
                    <div
                      v-if="!validations.orderPIP.receiver.phone.required"
                      class="calc__field-error"
                    >
                      Обязательно для заполнения
                    </div>

                    <div
                      v-else-if="!validations.orderPIP.receiver.phone.validPhone"
                      class="calc__field-error"
                    >
                      Заполните номер телефона
                    </div>
                    <div
                      v-else-if="validations.orderPIP.receiver.phone.$error && !orderPIP.receiver.phone.length"
                      class="calc__field-error"
                    >
                      Обязательно для заполнения
                    </div>
                    <div
                      v-else-if="validations.orderPIP.receiver.phone.$error && !validations.orderPIP.receiver.phone.validPhone"
                      class="calc__field-error"
                    >
                      Заполните номер телефона
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <CalcComment
          v-if="isCalcRfRf"
          class="mt-2"
        >
          <div class="d-flex align-items-center">
            <svg
              class="me-2"
              width="20px"
              height="20px"
            >
              <use xlink:href="#info2" />
            </svg>
            Все поля обязательны для заполнения
          </div>
        </CalcComment>
        <div class="calculator-form-checkbox-wrap">
          <ul class="calculator-form__fields calculator-form__fields_checkbox d-flex flex-column">
            <li class="calculator__checkbox mt-0">
              <div
                class="field-checkbox calc__checkbox"
                :class="{'calc__input-error': validations.orderPIP.sender.personal_agreement.$error}"
              >
                <input
                  id="personal_agreement"
                  v-model="orderPIP.sender.personal_agreement"
                  class="field-checkbox__input"
                  type="checkbox"
                  name="personal_agreement"
                  @change="validations.orderPIP.sender.personal_agreement.$touch()"
                >
                <label
                  style="display: flex !important;"
                  class="field-checkbox__label field-checkbox__label_personal_agreement"
                  for="personal_agreement"
                >
                  <a
                    class="calc__link-text"
                    :href="personalAgreementLink"
                    rel="noopener"
                    target="_blank"
                  >
                    Я&nbsp;согласен на&nbsp;обработку персональных данных и&nbsp;с&nbsp;Офертой Боксберри
                  </a>
                </label>
              </div>
              <div
                v-if="validations.orderPIP.sender.personal_agreement.$error"
                class="calc__field-error calc__field-error_checkbox"
              >
                Подтвердите обработку данных
              </div>
            </li>
            <li
              v-if="showCheckboxDocumentAgreement"
              class="calculator__checkbox"
            >
              <div
                class="field-checkbox"
                :class="{'calc__input-error': validations.orderPIP.sender.document_agreement.$error}"
              >
                <input
                  id="document_agreement"
                  v-model="orderPIP.sender.document_agreement"
                  class="field-checkbox__input"
                  type="checkbox"
                  name="document_agreement"
                  @change="validations.orderPIP.sender.document_agreement.$touch()"
                >
                <label
                  class="field-checkbox__label field-checkbox__label_document-agreement"
                  for="document_agreement"
                >
                  <i18n
                      path="document_agreement"
                      :tag="false"
                    >
                      <template #text>
                        <span class="document-agreement__text">{{ $t('oznakomlen-so-spiskom') }}</span>
                      </template>
                      <template #link>
                        <a
                          :href="personalAgreementLink"
                          class="calc__link-text"
                          target="_blank"
                          rel="noopener"
                        >
                          {{ $t('zapreshennykh-k-perevozke-gruzov') }}
                        </a>
                      </template>
                    </i18n>
                </label>
              </div>
              <div
                v-if="validations.orderPIP.sender.document_agreement.$error"
                class="calc__field-error calc__field-error_checkbox"
              >
                Подтвердите что ознакомились со списком
              </div>
            </li>
          </ul>
          <div
            v-if="!isCustoms && !isMobile"
            style="max-width: 90vw; overflow: hidden; flex-shrink: 0;"
          >
            <Recaptcha
              ref="recaptcha"
              :public-key="recaptchaKey"
              @verified="dataRecaptcha"
              @expired="removeDataRecaptcha"
            />
          </div>
        </div>
        <div class="calculator__cols">
          <div class="calculator__col">
            <template v-if="(!calcImport || receiverCanPay) || isCustoms">
              <div class="calculator-form__fields">
                <div class="calculator-form__field calculator-form__field_full-width">
                  <div class="calculator-field__label">
                    {{ $t('calc.form.kto-platit-za-dostavku') }}
                  </div>
                  <div
                    class="calc-radio-btn calc-radio-btn_fifth-step"
                    :class="{ 'active': orderPIP.payer_type === '1' }"
                    @click="orderPIP.payer_type = '1'"
                  >
                    <svg
                      v-if="orderPIP.payer_type === '1'"
                      class="calc-radio-btn__icon"
                      width="24px"
                      height="24px"
                    >
                      <use xlink:href="#select-on" />
                    </svg>
                    <svg
                      v-else
                      class="calc-radio-btn__icon"
                      width="24px"
                      height="24px"
                    >
                      <use xlink:href="#select-off" />
                    </svg>
                    <div class="calc-package-item__left">
                      <div class="calc-package-item__desc">
                        <div class="calc-radio-btn__name">
                          Отправитель
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="calc-radio-btn calc-radio-btn_fifth-step"
                    :class="{ 'active': orderPIP.payer_type === '2', 'disabled': disabledSelectPayerReceiver }"
                    @click="orderPIP.payer_type = '2'"
                  >
                    <svg
                      v-if="orderPIP.payer_type === '2'"
                      class="calc-radio-btn__icon"
                      width="24px"
                      height="24px"
                    >
                      <use xlink:href="#select-on" />
                    </svg>
                    <svg
                      v-else
                      class="calc-radio-btn__icon"
                      width="24px"
                      height="24px"
                    >
                      <use xlink:href="#select-off" />
                    </svg>
                    <div class="calc-package-item__left">
                      <div class="calc-package-item__desc">
                        <div class="calc-radio-btn__name">
                          Получатель
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="calculator__col">
            <CalcComment
              v-if="isCalcRfRf && false"
              class="calc-fifth__comment"
            >
              <template slot="icon">
                <svg
                  width="20px"
                  height="20px"
                >
                  <use xlink:href="#info2" />
                </svg>
              </template>
              <template slot="title">
                  Внимание!
              </template>
              После создания электронной накладной, оплатить сможет только отправитель
            </CalcComment>
            <CalcComment
              v-if="isCalcRfRf && false"
              class="calc-fifth__comment"
            >
              <template slot="icon">
                <svg
                  width="20px"
                  height="20px"
                >
                  <use xlink:href="#info2" />
                </svg>
              </template>
              <template slot="title">
                  Внимание!
              </template>
              После создания электронной накладной, оплатить сможет только отправитель
            </CalcComment>
            <template v-if="!isCustoms">
              <ul class="calculator-form__fields">
                <li
                  v-if="calcImport"
                  class="calculator-form__field calculator-form__field_input calculator-form__field_full-width"
                  :class="{'calc__input-error': validations.orderPIP.themes.$error && !validations.orderPIP.themes.validThemes}"
                >
                  <div class="calculator-field__label">
                    Описание вложения
                  </div>
                  <div class="field-input calc__input">
                    <SelectWithCheckbox
                      v-model="themes"
                      :options="themesOptions"
                      placeholder="Категория вложения"
                      class="calculator__select-with-checkbox"
                    />
                  </div>
                  <CalcComment class="mt-2">
                    <div class="d-flex align-items-center">
                      <svg
                        class="me-2"
                        width="20px"
                        height="20px"
                      >
                        <use xlink:href="#info2" />
                      </svg>
                      Вы можете выбрать несколько категорий
                    </div>
                  </CalcComment>
                  <div
                    v-if="validations.orderPIP.themes.$error && !validations.orderPIP.themes.validThemes"
                    class="calc__field-error"
                  >
                    Обязательно для заполнения
                  </div>
                </li>
              </ul>
            </template>
            <div
              v-if="!isCustoms && isMobile"
              class="mt-4 d-flex align-items-center justify-content-center"
              style="max-width: 90vw; overflow: hidden; flex-shrink: 0;"
            >
              <Recaptcha
                ref="recaptcha"
                :public-key="recaptchaKey"
                @verified="dataRecaptcha"
                @expired="removeDataRecaptcha"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <CalcNavDesktop
      v-if="!isMobile"
      :is-loading="isLoading"
      :error-text="navErrorText"
      @stepValidation="fifthStepValidation"
      @step-back="() => {
        $emit('step-back');
        resetConfirmReceiverDetailsOtherCountry();
      }"
    >
      <template #btnNext>
        Оформить
      </template>
    </CalcNavDesktop>
    <CalcNavMobile
      v-else
      :is-loading="isLoading"
      :error-text="navErrorText"
      @stepValidation="fifthStepValidation"
      @step-back="() => {
        $emit('step-back');
        resetConfirmReceiverDetailsOtherCountry();
      }"
    >
      <template #btnNext>
        Оформить
      </template>
    </CalcNavMobile>

    <CalculatorModalReceiverAccept
      v-if="recipientDetailsOtherCountry && modalRecipientDetailsOtherCountry.show"
      :receiver-details="orderPIP.receiver"
      @confirmReceiverDetails="confirmReceiverDetailsOtherCountry"
      @changeReceiverDetails="changeReceiverDetailsOtherCountry"
    />
  </div>
</template>

<script>
/* global apiUrl */
import CalcComment from './components/CalcComment.vue';
import InputPhone from '../ComponentsForm/InputPhone.vue';
import Recaptcha from '../ComponentsForm/Recaptcha.vue';
import { submitOrder, submitOrderImport } from '../../models/calculator-pip';
import CalculatorModalReceiverAccept from './CalculatorModalReceiverAccept.vue';
import SelectWithCheckbox from '../ComponentsForm/SelectWithCheckbox.vue';
import { COUNTRY_CODES } from '../../helpers/constans';
import InputNameLatin from '../ComponentsForm/InputNameLatin.vue';
import CalcNavDesktop from './components/CalcNavDesktop.vue';
import CalcNavMobile from './components/CalcNavMobile.vue';
import deviceInfo from '../../helpers/device';
import scrollToEl from '../../mixins/scrollToEl';

const axios = require('axios');

const NEW_API_URL = apiUrl;

export default {
  name: 'CalculatorPIP5thStepView',
  components: {
    CalcNavMobile,
    CalcNavDesktop,
    CalcComment,
    InputNameLatin,
    SelectWithCheckbox,
    InputPhone,
    Recaptcha,
    CalculatorModalReceiverAccept,
  },
  mixins: [scrollToEl],
  props: ['orderPIP', 'orderCalcPIP', 'validations', 'order_num', 'errorDictionary', 'salePip', 'calcImport',
    'totalPrice', 'hideFormEmail', 'receiverCanPay', 'receiverPayImport', 'isCustoms',
    'personalAgreementLink'],
  data() {
    return {
      recaptchaKey: window.recaptchaKey || null,
      dataCaptcha: null,
      isLoading: false,
      modalRecipientDetailsOtherCountry: {
        show: false,
        confirmation: false,
      },
      themes: null,
      themesOptions: [],
    };
  },
  computed: {
    ...deviceInfo,
    recipientDetailsOtherCountry() {
      return this.orderPIP.receiver.country !== COUNTRY_CODES.RUSSIA
        && this.orderPIP.receiver.country !== COUNTRY_CODES.KAZAKHSTAN;
    },
    isPassportRus() {
      return this.orderPIP.passport_type === '1';
    },
    getPassportTypeStyle() {
      return this.calcImport ? { order: '-1' } : {};
    },
    hideInputPassport() {
      return this.isPassportRus && this.orderPIP.sender.country === COUNTRY_CODES.RUSSIA && this.orderPIP.receiver.country === COUNTRY_CODES.RUSSIA;
    },
    hideAllPassport() {
      return this.orderPIP.sender.country === COUNTRY_CODES.RUSSIA && this.orderPIP.receiver.country !== COUNTRY_CODES.RUSSIA;
    },
    receiverCanAcceptPayment() {
      if (this.orderPIP.receiver.country === COUNTRY_CODES.BELARUS) return (this.orderPIP.receiver.acquiring && this.orderPIP.receiver.cashPayment);
      return (this.orderPIP.receiver.acquiring || this.orderPIP.receiver.cashPayment);
    },
    senderNoPay() {
      return !(this.orderPIP.sender.acquiring || this.orderPIP.sender.cashPayment);
    },
    navErrorText() {
      if (this.validations && this.validations.$error) return 'Пожалуйста, заполните все отмеченные поля';
      return '';
    },
    isCalcRfRf() {
      return this.orderPIP.sender.country === COUNTRY_CODES.RUSSIA && this.orderPIP.receiver.country === COUNTRY_CODES.RUSSIA;
    },
    disabledSelectPayerReceiver() {
      const receiverCanPayByCountry = this.orderPIP.receiver.country === COUNTRY_CODES.RUSSIA
      || this.orderPIP.receiver.country === COUNTRY_CODES.KAZAKHSTAN || this.orderPIP.receiver.country === COUNTRY_CODES.BELARUS;
      return (this.calcImport && !this.receiverCanPay) || !this.receiverCanAcceptPayment || !receiverCanPayByCountry;
    },
    showCheckboxDocumentAgreement() {
      return this.orderPIP.sender.country === COUNTRY_CODES.RUSSIA;
    },
  },
  watch: {
    themes(val) {
      this.orderPIP.themes = val;
    },
  },
  beforeMount() {
    this.orderPIP.payer_type = '1';

    if (this.isCustoms) {
      this.orderPIP.passport_type = '1';
      return;
    }

    if (!this.calcImport) {
      this.orderPIP.passport_type = '1';
    } else {
      this.fetchLandingCalcPipCategory();
      this.orderPIP.passport_type = '2';
    }
  },
  methods: {
    fifthStepValidation() {
      const fieldsValidate = this.validations.orderPIP.receiver.name.required
        && this.validations.orderPIP.receiver.name.validName
        && this.validations.orderPIP.receiver.name.validNameLatin
        && this.validations.orderPIP.receiver.phone.required
        && this.validations.orderPIP.receiver.phone.validPhone
        && this.validations.orderPIP.sender.name.required
        && this.validations.orderPIP.sender.name.validName
        && this.validations.orderPIP.sender.name.validNameLatin
        && this.validations.orderPIP.sender.phone.required
        && this.validations.orderPIP.sender.phone.validPhone
        && ((this.validations.orderPIP.sender.email.validFormat && this.validations.orderPIP.sender.email.required) || this.hideFormEmail)
        && this.validations.orderPIP.themes.validThemes

        && (this.orderPIP.passport_type === '1'
          ? ((this.validations.orderPIP.sender.document_series.required
          && this.validations.orderPIP.sender.document_series.minLength
          && this.validations.orderPIP.sender.document_num.required
          && this.validations.orderPIP.sender.document_num.minLength) || this.hideInputPassport || this.hideAllPassport)
          : this.validations.orderPIP.sender.document_num_other.required)
        && !this.validations.orderPIP.sender.personal_agreement.$invalid
        && (!this.showCheckboxDocumentAgreement || !this.validations.orderPIP.sender.document_agreement.$invalid)
        && (this.dataCaptcha !== null || this.isCustoms);

      if (fieldsValidate) {
        if (this.orderPIP.passport_type === '1') {
          if (this.hideInputPassport) {
            this.orderPIP.sender.document_series = '';
            this.orderPIP.sender.document_num = '';
          }
          this.orderPIP.sender.document_num_other = '';
        } else {
          this.orderPIP.sender.document_series = '0000';
          this.orderPIP.sender.document_num = this.orderPIP.sender.document_num_other;
        }

        if (this.hideAllPassport) {
          this.orderPIP.sender.document_series = '';
          this.orderPIP.sender.document_num = '';
          this.orderPIP.sender.document_num_other = '';
        }

        if (this.recipientDetailsOtherCountry && !this.modalRecipientDetailsOtherCountry.confirmation) {
          this.modalRecipientDetailsOtherCountry.show = true;
        } else {
          if (!this.isCustoms) {
            this.orderPIP.dataCaptcha = this.dataCaptcha;
          }
          this.fifthStepHandler();
        }
      } else {
        this.$emit('someAction');
      }
    },
    fifthStepHandler() {
      this.isLoading = true;
      this.orderPIP.promo_code = this.orderCalcPIP.promo_code;

      if (this.isCustoms) {
        this.$emit('step-up-customs');
        return;
      }

      if (!this.calcImport) {
        submitOrder(this.orderPIP, this.errorDictionary, this.orderCalcPIP, this.salePip, false, false, this.totalPrice)
          .then((orderNumber) => {
            this.$emit('step-up', orderNumber);
          })
          .catch((errArr) => {
            this.$emit('error', errArr.message);
          })
          .finally(() => {
            this.isLoading = false;
            this.resetConfirmReceiverDetailsOtherCountry();
          });
      } else {
        submitOrderImport(this.orderPIP, this.errorDictionary, this.orderCalcPIP, this.totalPrice, this.dataCaptcha, this.receiverCanPay)
          .then((orderInfo) => {
            if (this.receiverPayImport) {
              this.$emit('step-up', orderInfo.orderId);
            } else {
              this.$emit('step-up-import', orderInfo);
            }
          })
          .catch((errArr) => {
            this.$emit('error', errArr.message);
            this.$refs.recaptcha.reset();
          })
          .finally(() => {
            this.isLoading = false;
            this.resetConfirmReceiverDetailsOtherCountry();
          });
      }
    },
    dataRecaptcha(value) {
      this.dataCaptcha = value;
    },
    removeDataRecaptcha() {
      this.dataCaptcha = null;
      this.orderPIP.dataCaptcha = null;
    },
    onEnteredPhoneSender(value) {
      this.orderPIP.sender.phone = value.valuePhone;
    },
    onEnteredPhoneReceiver(value) {
      this.orderPIP.receiver.phone = value.valuePhone;
    },
    confirmReceiverDetailsOtherCountry() {
      this.modalRecipientDetailsOtherCountry.show = false;
      this.modalRecipientDetailsOtherCountry.confirmation = true;
      this.fifthStepValidation();
    },
    resetConfirmReceiverDetailsOtherCountry() {
      this.modalRecipientDetailsOtherCountry.show = false;
      this.modalRecipientDetailsOtherCountry.confirmation = false;
    },
    changeReceiverDetailsOtherCountry(value) {
      this.orderPIP.receiver.name = value;
    },
    fetchLandingCalcPipCategory() {
      const url = `${NEW_API_URL}/landing/calc/category`;

      axios.get(url)
        .then((resp) => {
          this.themesOptions = resp.data.map(((item) => ({ ...item, value: item.name })));
        })
        .catch((e) => {
          console.error(e);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.calculator-form__field_customs {
  display: flex;
  & > .field-input {
    flex-grow: 1;
  }
  @media (max-width: 767px) {
    flex-direction: row !important;
  }
}
</style>
<style lang="scss">
.calculator-form__field_customs .help {
  align-self: flex-start;
  top: 20px;
  @media (max-width: 767px) {
    flex-direction: row !important;
    margin-left: 18px;
  }
}
.calc-radio-btn_fifth-step {
  display: flex;
  align-items: center;
  min-height: 48px;
  .calc-radio-btn__name {
    margin-bottom: 0 !important;
    color: #50616F !important;
  }
  &.active {
    .calc-radio-btn__name {
      color: #333 !important;
    }
  }
}
.calculator__col {
  @media (max-width: 767px) {
    padding: 0 !important;
    border: none !important;
  }
}
.calculator-form__fields_checkbox {
  @media (max-width: 767px) {
    margin-right: 0 !important;
  }
}
.calculator__cols {
  @media (min-width: 768px) {
    margin-bottom: 24px !important;
  }
}
.calculator-form-checkbox-wrap {
  display: flex;
  align-items: center;
  margin-top: 24px !important;
  @media (min-width: 768px) {
    padding-right: 60px;
  }
}
.calc-fifth__comment {
  margin-top: 8px;
  @media (min-width: 768px) {
    margin-top: 46px !important;
  }
}
.calculator__select-with-checkbox .multiselect__element .multiselect__option {
  padding-left: 45px !important;
}
.multiselect.field-input__inner.calculator__select-with-checkbox.multiselect--active {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.field-checkbox__label_personal_agreement {
  display: inline !important;
}
.calc__field-error_checkbox {
  margin-left: 32px !important;
}
.field-checkbox__label_document-agreement {
  @media (max-width: 767px) {
    display: inline-block !important;
    span {
      margin-right: 0 !important;
    }
  }
}
</style>
